/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconCoreDownload = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M15.723 9.105a4.927 4.927 0 0 0-4.927-4.927c-.33 0-.652.037-.964.099l.004 6.592 2.348-2.33a.525.525 0 0 1 .729 0 .499.499 0 0 1-.004.707l-3.528 3.539-3.54-3.538c-.196-.196-.202-.513-.006-.708s.499-.196.695 0l2.306 2.33-.004-7.486c-.645-.451-1.413-.738-2.261-.738a4.02 4.02 0 0 0-4.02 4.021c0 .432.086.84.212 1.23a3.1 3.1 0 0 0 .612 6.136h7.421a4.927 4.927 0 0 0 4.927-4.927z"
    />
  </svg>
);

IconCoreDownload.displayName = 'IconCoreDownload';

IconCoreDownload.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconCoreDownload);
IconCoreDownload.displayName = 'IconCoreDownload';
